/* eslint-disable @angular-eslint/prefer-standalone -- This dialog intentionally remains declared by SettingsModule. */
import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {SurveyorLicence, SurveyorLicenceUser} from '@src/app/core/services/payment.service';

export interface SurveyorLicenceAssignmentDialogData {
    licence: SurveyorLicence;
    users: SurveyorLicenceUser[];
}

@Component({
    standalone: false,
    selector: 'app-surveyor-licence-assignment-dialog',
    templateUrl: './surveyor-licence-assignment-dialog.component.html',
})
export class SurveyorLicenceAssignmentDialogComponent
{
    public readonly data = inject<SurveyorLicenceAssignmentDialogData>(MAT_DIALOG_DATA);
    public userId: number | null = null;
}
